import { ODSDatePicker, type ODSDatePickerFormat, type ODSDatePickerProps } from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';

const flyoutProps = {
  monthButtonProps: {
    'aria-label': 'Switch to month view',
  },
  nextMonthButtonProps: {
    'aria-label': 'Go to next month',
  },
  previousMonthButtonProps: {
    'aria-label': 'Go to previous month',
  },
  yearButtonProps: {
    'aria-label': 'Switch to year view',
  },
};

interface DateFieldProps {
  id: string;
  name: string;
  format?: ODSDatePickerFormat;
  size?: 'small' | 'large';
  value?: string | Date;
  maxDate?: Date;
  minDate?: Date;
  onChange?: ODSDatePickerProps['onChange'];
  onBlur?: ODSDatePickerProps['onBlur'];
  label: string;
  disabled?: boolean;
  helperText?: string;
}

export const DateField: FC<DateFieldProps> = ({
  id,
  name,
  format = 'DD.MM.YYYY',
  size = 'small',
  value,
  maxDate,
  minDate,
  onChange,
  onBlur,
  label,
  disabled = false,
  helperText,
}) => (
  <ODSDatePicker
    id={id}
    aria-label={name}
    flyoutProps={flyoutProps}
    format={format}
    inputProps={{
      disabled,
      label,
      placeholder: value as string,
      mode: helperText ? 'informative' : 'standard',
      ...(helperText && {
        supportMessageProps: {
          helperText,
          message: helperText,
        },
      }),

    }}
    {...(maxDate && { maxDate })}
    {...(minDate && { minDate })}
    {...(onChange && { onChange })}
    size={size}
    defaultDate={value as Date}
    onBlur={onBlur}
  />
);